module.exports = __webpack_public_path__ + "static/media/truck10.63ca27a6.jpg";